import { DatePickerView } from './DatePickerView'

export type { DatePickerViewProps } from './iDatePickerView'

export default DatePickerView
